import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'
import { LEGAL_PAGES } from '../data/meta'

export default function PrivacyPolicy() {
  const page = LEGAL_PAGES.privacy
  return (
    <>
      <SEO title={page.title} description={page.description} canonical={page.url} structuredData={{ '@context': 'https://schema.org', '@type': 'WebPage', name: page.title, description: page.description }} />
      <Navbar />
      <div className="legal-page">
        <div className="legal-page-content">
          <h1>Privacy Policy</h1>
          <p>Last updated: July 2026</p>

          <h2>1. Data We Collect</h2>
          <p>
            We collect account credentials, payment details via Razorpay, and usage data for our AI services.
            Any sensitive information you provide is processed securely and only for the purpose of delivering our services.
          </p>

          <h2>2. How We Use Data</h2>
          <p>
            Data is used to operate the platform, improve AI models, process subscriptions, and provide support.
            We do not sell personal data to third parties.
          </p>

          <h2>3. Retention</h2>
          <p>
            Account data is retained while your account is active. You may request deletion by contacting support.
          </p>

          <h2>4. Your Rights</h2>
          <p>
            Under Indian law, you may request access, correction, or deletion of your data. Contact us at support@tredextechnology.in or business@tredextechnology.in.
          </p>

          <h2>5. Security</h2>
          <p>
            We use industry-standard encryption and access controls. However, no system is completely secure.
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}
